import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["action"];
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import unescapedText from 'I18n/utils/unescapedText';
import { useCompatibility } from 'marketplace-ui-common/compatibility/hooks/useCompatibility';
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import { CompatibilityModal } from 'marketplace-ui-details/compatibility/CompatibilityModal';
import { jsx as _jsx } from "react/jsx-runtime";
export const FeatureCompatibilityModal = ({
  appContext,
  onClose,
  assetScopes,
  offeringType,
  trackInteraction
}) => {
  const scopeFeatures = assetScopes.reduce((acc, scope) => {
    const scopeFeatureI18nKey = `marketplace-assets-ui.scopeFeatures.${scope}-title`;
    if (isValidI18nKey(scopeFeatureI18nKey)) {
      const feature = {
        text: unescapedText(scopeFeatureI18nKey),
        scopes: [scope]
      };
      return acc.concat(feature);
    }
    return acc;
  }, []);
  const tierGroupNames = ['CRM', 'CONTENT', 'MARKETING', 'OPERATIONS', 'SALES', 'SERVICE'];
  const {
    compatibilityRequestState,
    featuresWithTierCompatibility,
    portalTiers
  } = useCompatibility({
    appContext,
    offeringType,
    scopeFeatures,
    tierGroupNames
  });
  return /*#__PURE__*/_jsx(LoadingWrapper, {
    requestStatus: compatibilityRequestState,
    children: /*#__PURE__*/_jsx(CompatibilityModal, {
      appContext: appContext,
      featuresWithTierCompatibility: featuresWithTierCompatibility,
      onClose: onClose,
      onTrackInteraction: _ref => {
        let {
            action
          } = _ref,
          eventProps = _objectWithoutPropertiesLoose(_ref, _excluded);
        return trackInteraction(action, eventProps);
      },
      portalTiers: portalTiers,
      productType: offeringType
    })
  });
};